import styled from '@emotion/styled';

export const InputDropdownContent = styled.div<{ disabled?: boolean }>`
  width: 100%;
  padding: 12px;
  background-color: ${({ disabled, theme }) =>
    disabled ? theme.palette?.grey?.[200] : theme.palette?.common?.white};
  width: 100%;
  height: 100%;
  height: 2.9rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  border: 1px solid #E6E5EA;

  &:hover {
    border-color: ${({ theme }) => theme.palette?.brand?.primary.base};
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.palette?.brand?.primary.base};
  }
`;

export const ButtonArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 17px;
  cursor: pointer;
`;
